class RosterSlider {
  constructor(el) {
    var tSautoPlayTimeout = 6000 + Math.random()*3000;
    if (window.tns) {
      var slider = tns({
        container: el,
        items: 1,
        autoplay: true,
        nav: false,
        controls: false,
        lazyloadSelector: ".tns-lazy",
        lazyload: true,
        mouseDrag: true,
        autoplayButtonOutput: false,
        autoplayTimeout: tSautoPlayTimeout,
        speed: 800,
        responsive: {
         460: {
           items:2,
         },
         700: {
           items: 3,
         },

        }
      });
    }
  }
}

(function () {
  //Only init once
  var initializeBlock = function ($block) {

    var mySwiper = $block.querySelector('.roster-slider');
    new RosterSlider(mySwiper);
  };

  var initializeBlockJQ = function ($block) {
    var mySwiper = $block.find('.roster-slider');


    if (document && mySwiper.length) {
      new RosterSlider(mySwiper[0]);
    }
  };
  if (window.acf) {
    window.acf.addAction(
      'render_block_preview/type=roster-slider',
      initializeBlockJQ
    );
  } else {

    const parents = document.querySelectorAll('.roster-block');

    parents.forEach(el=> {
      initializeBlock(el);
    })
  }

})();
